module.exports = __webpack_public_path__ + "img/ods-logo-header.2eea9f68.png";